// A small contextual "Docs" link → the relevant page on docs.apistash.dev.
export default function DocsLink({ path, label = "Docs" }: { path: string; label?: string }) {
  return (
    <a
      href={`https://docs.apistash.dev${path}`}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1 text-xs muted hover:text-text"
      title="Open documentation"
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M14 3v5h5M8 13h8M8 17h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      {label}
    </a>
  );
}
